<template>
  <PagePart
      :setTitle="setTitle"
      :setBreadcrumbs="setBreadcrumbs"
  >
    <template
        v-slot:default="{
          title,
          backLink
        }"
    >
      <slot
          name="default"
          :title="title"
          :backLink="backLink"
      />
    </template>
  </PagePart>
</template>

<script>
  import PagePart from '@/components/_Part/Page'

  export default {
    name: 'Blank',
    props: [
      'setTitle',
      'setBreadcrumbs'
    ],
    components: {
      PagePart
    }
  }
</script>
